import { onDocumentEvent } from '@app/utils/domHelpers'

const visitRoute = (e) => {
  Turbolinks.visit(e.target.value)
}

export default () =>
  onDocumentEvent(
    document,
    'change',
    '[data-behaviour~="export-bundle-select"]',
    visitRoute
  )
